import { combineReducers } from 'redux-immutable'
import user from './userReducer'
import mentions from './mentionsReducer'
import twitter from './twitterReducer'
import userInterface from './userInterfaceReducer'
import firebase from './firebaseReducer'
import settings from './settingsReducer'
import facebook from './facebookReducer'
export default combineReducers({ user,mentions,twitter,userInterface,firebase,settings,facebook})
